import { cn } from "@tellescope/design-system";
import { ChevronDown } from "lucide-react";
import { useTranslation } from "react-i18next";

export interface BlockExpandToggleProps {
  expanded: boolean;
  onToggle: () => void;
}

export const BlockExpandToggle = ({ expanded, onToggle }: BlockExpandToggleProps) => {
  const { t } = useTranslation("contacts");

  return (
    <button
      type="button"
      aria-label={expanded ? t("Collapse block") : t("Expand block")}
      onClick={onToggle}
      className={cn(
        "absolute bottom-2 left-1/2 -translate-x-1/2 z-10 flex items-center justify-center",
        "size-7 rounded-full border bg-background text-muted-foreground shadow-sm",
        "hover:bg-secondary hover:text-foreground transition-colors"
      )}
    >
      <ChevronDown className={cn("size-4 transition-transform", expanded && "rotate-180")} />
    </button>
  );
};
